import React from 'react';
const reviews = [{
  name: 'Joe Cherluck',
  rating: 5,
  time: 'a year ago',
  text: 'Purchased a used Wire EDM from Peak Machine Sales. True wizards in service. 5 star service from finance recommendations, delivery of the equipment, to service in getting the machine up and running. 7 days from close on the machine to making first parts. Could not ask for a better experience.'
}, {
  name: 'Kevin Vallelunga',
  rating: 5,
  time: '4 days ago',
  text: 'New owner of EDM Machine. Eric and Crew at peak have been instrumental in our successful implementation. We will continue to utilize them at every opportunity.',
  badge: 'NEW'
}, {
  name: 'Louis Oudin',
  rating: 5,
  time: 'a year ago',
  text: 'Thanks to Matt for the great job he did on our Cut E 350. Very thorough and efficient on the PM of our machine.',
  source: 'Sonic EDM'
}];
export function CustomerReviewsSection() {
  return <div data-id="element-1631">
      <h3 className="text-xl font-bold text-navy text-center mb-6" data-id="element-1632">
        What Our Customers Say
      </h3>
      <div className="grid md:grid-cols-3 gap-6" data-id="element-1633">
        {reviews.map(review => <div key={review.name} className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-1634">
            <div className="flex items-center gap-3 mb-3" data-id="element-1635">
              <div className="w-10 h-10 rounded-full bg-navy text-white flex items-center justify-center font-bold text-sm" data-id="element-1636">
                {review.name.charAt(0)}
              </div>
              <div data-id="element-1637">
                <p className="font-bold text-gray-900 text-sm" data-id="element-1638">{review.name}</p>
                <p className="text-xs text-gray-500" data-id="element-1639">{review.time}</p>
              </div>
              {review.badge && <span className="ml-auto text-xs bg-orange text-white px-2 py-0.5 rounded font-bold" data-id="element-1640">
                  {review.badge}
                </span>}
            </div>
            <div className="flex items-center gap-0.5 mb-3" data-id="element-1641">
              {Array.from({
            length: review.rating
          }).map((_, i) => <svg key={i} className="w-5 h-5 text-yellow-400 fill-current" viewBox="0 0 20 20" data-id="element-1642">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-1643" />
                </svg>)}
            </div>
            <p className="text-gray-700 text-sm leading-relaxed" data-id="element-1644">
              {review.text}
            </p>
            {review.source && <p className="text-xs text-gray-400 mt-3" data-id="element-1645">{review.source}</p>}
          </div>)}
      </div>
    </div>;
}